import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Apply the persisted theme before first paint to avoid a flash of the wrong
// theme (T-020). Mirrors the default logic in store/configStore.js.
(function applyInitialTheme() {
  try {
    const saved = localStorage.getItem("theme");
    const isDark = saved
      ? saved === "dark"
      : window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (isDark) document.documentElement.classList.add("dark");

    // T-217: aplicar el nivel de contraste persistido antes del primer paint
    // para evitar un flash de bajo contraste. Espejo de applyContrast() en el
    // store: 'normal' no deja atributo; 'alto'/'extremo' setean data-contrast.
    const savedContrast = localStorage.getItem("contrast");
    if (savedContrast === "alto" || savedContrast === "extremo") {
      document.documentElement.setAttribute("data-contrast", savedContrast);
    }

    // T-222: aplicar la paleta persistida antes del primer paint para evitar
    // un flash de la paleta base. Espejo de applyPalette() en el store: '' no
    // deja atributo; los 5 valores válidos setean data-palette.
    const savedPalette = localStorage.getItem("palette");
    if (
      savedPalette === "sepia" ||
      savedPalette === "oceano" ||
      savedPalette === "bosque" ||
      savedPalette === "medianoche" ||
      savedPalette === "violeta"
    ) {
      document.documentElement.setAttribute("data-palette", savedPalette);
    }
  } catch (e) {
    // ignore — theme/contrast fall back to light/normal
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
